import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
import React from "react";
var __jsx = React.createElement;
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import { Image, Pressable, View } from 'react-native';
import { isWeb } from '~/common/Env';
import { LocalImageEnum, localImageSource } from '~/common/Helpers';
import Localize from '~/common/Localize';
import { Body3, Container, SubTitle2, Theme, themed } from '~/styles/Theme';
export var NotificationBannerItemHeight = 70;
var NotificationBannerItem = /*#__PURE__*/function (_Component) {
  _inherits(NotificationBannerItem, _Component);
  var _super = _createSuper(NotificationBannerItem);
  function NotificationBannerItem() {
    _classCallCheck(this, NotificationBannerItem);
    return _super.apply(this, arguments);
  }
  _createClass(NotificationBannerItem, [{
    key: "render",
    value: function render() {
      var item = __jsx(VerticalContainer, {
        testID: "announcementBanner"
      }, __jsx(HorizontalContainer, null, __jsx(View, {
        style: {
          flexDirection: 'row',
          flexShrink: 1
        }
      }, __jsx(ImageContainer, null, __jsx(Image, {
        style: {
          width: 40,
          height: 40
        },
        resizeMode: "contain",
        source: localImageSource(LocalImageEnum.loudspeaker)
      })), __jsx(TextContainer, null, __jsx(SubTitle2, {
        adjustsFontSizeToFit: true
      }, this.props.title), __jsx(Body3, {
        numberOfLines: 1,
        ellipsizeMode: "tail",
        testID: "bannerText"
      }, decode(this.props.subtitle)))), __jsx(ReadMoreLink, null, Localize('home.readMore'))));
      return this.props.onPress ? __jsx(Pressable, {
        onPress: this.props.onPress,
        testID: 'announcementBannerTouch',
        role: "button",
        style: function style(_ref) {
          var pressed = _ref.pressed;
          return [{
            opacity: pressed ? 0.6 : 1
          }];
        }
      }, item) : item;
    }
  }]);
  return NotificationBannerItem;
}(Component);
export { NotificationBannerItem as default };
function decode(text) {
  var escapeMap = new Map([['&quot;', '"'], ['&amp;', '&'], ['&#x27;', "'"], ['&lt;', '<'], ['&gt;', '>'], ['&#x60;', '`']]);
  var decodedText = text;
  escapeMap.forEach(function (value, key) {
    decodedText = decodedText.replace(new RegExp(key, 'g'), value);
  });
  return decodedText.replace(/<[^>]+>/g, '');
}
var VerticalContainer = themed(Container)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  justify-content: center;\n  background-color: ", ";\n  border-radius: 8px;\n  padding: 10px 20px;\n  elevation: 1;\n  ", "\n  border-width: 2px;\n  border-color: transparent;\n  height: ", "px;\n"])), function (props) {
  return Theme(props).colors.neutral;
}, function (props) {
  return isWeb() ? "box-shadow: 2px 2px 4px ".concat(Theme(props).colors.opacity2) : '';
}, NotificationBannerItemHeight);
var HorizontalContainer = themed(Container)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex-direction: row\n  align-items: center\n  justify-content: space-between\n"])));
var ImageContainer = themed(Container)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  padding-right: 20px\n"])));
var TextContainer = themed(Container)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  flex-shrink: 1\n  word-wrap: break-word;\n"])));
var ReadMoreLink = themed(Body3)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n  width: 40px;\n"])), function (props) {
  return "color: ".concat(Theme(props).colors.info);
});